import { AnimatePresence, motion } from 'framer-motion';

interface SessionBackgroundProps {
  src: string;
  showPulse: boolean;
}

const SessionBackground: React.FC<SessionBackgroundProps> = ({
  src,
  showPulse,
}) => {
  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full blur-[4px] opacity-70">
        {src && (
          <img
            src={src}
            alt="Avatar"
            className="w-full h-full object-cover z-[1]"
          />
        )}
      </div>
      <AnimatePresence>
        {showPulse && (
          <motion.div
            className="fixed inset-0 pointer-events-none z-10"
            style={{
              background: 'rgba(255, 255, 255, 0.05)',
            }}
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              boxShadow: [
                'inset 0 0 60px 12px rgba(255, 255, 255, 0.6)',
                'inset 0 0 100px 25px rgba(255, 255, 255, 0.8)',
                'inset 0 0 60px 12px rgba(255, 255, 255, 0.6)',
              ],
            }}
            exit={{ opacity: 0 }}
            transition={{
              opacity: { duration: 0.4, ease: 'easeOut' },
              boxShadow: {
                duration: 2,
                ease: 'easeInOut',
                repeat: Infinity,
              },
            }}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default SessionBackground;
